import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";


import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';




const restLink_account = new HttpLink({ 
  uri: "/api/v1/account/",
  credentials: 'include'
});
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});


const restLink_dam = new HttpLink({ 
  uri: "/api/v1/dam/",
  credentials: 'include'
});
const dam_client = new ApolloClient({
  link: restLink_dam,
  cache: new InMemoryCache(),
});


const restLink_lms = new HttpLink({ credentials: 'include', uri: "/api/v1/lms/" });
const lms_client = new ApolloClient({
  link: restLink_lms,
  cache: new InMemoryCache(),
});

const GET_AUTH_USER = gql`{
  get_authenticated_user{
    id
    profile{
      id
      is_admin
    }
  }
}
`;

const GET_TRAIL = gql`
query getTrails($category_id:Int!){
    trails_collections(category_id:$category_id){
      trails{
        id,title, thumbnail
      }
    }
  }
`;



const GET_TRAILITEMS = gql`
  query getItens($trail_id: Int!){
    trailitems(trail_id:$trail_id) {
      trailitems{
        item_id, item_type
      }
    }
  }
`;

const GET_CURSE = gql`
  query getCourse($course_id: Int!){
    course(id:$course_id){
      id, title, thumbnail
    }
  }
`;

const GET_ASSET = gql`
  query getAsset($dam_id: Int!){
    asset(id:$dam_id){
      id, title, thumbnail
    }
  }
`;


const GET_TRAIL_HAS_USER_ITEM = gql`
  query trail_has_user_item($trail_id: Int!){
    trail_has_user_item(trail_id:$trail_id) {
        id
        status
      }
    }
`;


class TrailList extends Component {
  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }
  render() {
    
    const windowWidth = window.innerWidth;

    var settings_courses = {
      autoplay: false,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: (windowWidth <= 987 ? 2 : 4),
      slidesToScroll: (windowWidth <= 987 ? 2 : 4)
    };
    return (
        <div>
           <a href="/#/home" className="btn btn-primary btn-fill">Voltar para Primeira Página</a>

<Table striped hover>
                    <tbody>
         <Query
  client={account_client}
  query={GET_AUTH_USER}
  >
  {({ loading, error, data }) => {
    if (loading) return <tr><td>Carregando...</td></tr>;
    if (error) return <tr><td>Erro 1:(</td></tr>;

    var auth_user = data.get_authenticated_user;


      return  ( 
<Query
  client={lms_client}
  query={GET_TRAIL}
  variables={{category_id:this.props.category_id}}
  >
  {({ loading, error, data }) => {
    if (loading) return <tr><td>Carregando...</td></tr>;
    if (error) return <tr><td>Erro 1:(</td></tr>;



      return data.trails_collections.trails.map((item_trail) => (

        <tr>
          
              <Query
                client={lms_client}
                variables={{trail_id:item_trail.id}}
                query={GET_TRAILITEMS}
                >
                {({ loading, error, data }) => {
                  if (loading) return <tr><td>Carregando...</td></tr>;
                  if (error) return <tr><td>Erro :(</td></tr>;
                    
                    const item = data.trailitems.trailitems[0];
                    if(!item) {
                      return <div></div>;
                    }

                    return (
                              <React.Fragment>
                            
                              <td>
                                {item_trail.title}
                              </td>
                              <td>
                                {
                                  auth_user.profile && auth_user.profile.id === 2 &&
                                    <a className="btn btn-fill btn-primary pull-right" href={"/#/report/"+item_trail.id}>
                                      Relatório dessa trilha
                                    </a>
                                }
                              </td>
                                


                            </React.Fragment>
                            
                    )
              }}
              </Query>

          </tr>
        
      ));
      }}
      </Query>

);
}}
</Query>

</tbody>
</Table>
      </div>
    );
  }
}

export default TrailList;



// WEBPACK FOOTER //
// ./src/components/Trail/ListReport.jsx